import { useState } from 'react';
import '../../styles/Footer.scss';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubscription = () => {
    if (validateEmail(email)) {
      setSubscribed(true);
      setError('');
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    } else {
      setError('Please enter a valid email address');
      setSubscribed(false);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    handleSubscription();
  };

  return (
    <footer className="footer">
      {/* Honey Wave Top */}
      <div className="footer__honey-top">
        <svg
          className="footer__honey-wave-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 180"
          preserveAspectRatio="none"
        >
          <path
            d="M0,96 C240,180 480,96 720,140 C960,180 1200,100 1440,140 L1440,180 L0,180 Z"
            className="footer__wave-path footer__wave-path--1"
          ></path>
          <path
            d="M0,120 C240,60 480,130 720,80 C960,40 1200,110 1440,70 L1440,180 L0,180 Z"
            className="footer__wave-path footer__wave-path--2"
          ></path>
          <path
            d="M0,140 C360,80 600,160 960,100 C1200,60 1320,140 1440,100 L1440,180 L0,180 Z"
            className="footer__wave-path footer__wave-path--3"
          ></path>
        </svg>
      </div>

      <div className="footer__container">
        <div className="footer__content">
          {/* Brand Section */}
          <div className="footer__section footer__section--brand">
            <div className="footer__logo-wrapper">
              <div className="footer__logo-glow"></div>
              <img
                src="/WhatsApp Image 2025-01-24 at 10.21.20 AM.jpeg"
                alt="Company Logo"
                className="footer__logo"
              />
            </div>

            <p className="footer__tagline">
              Premium Honey Solutions for a Sweeter Life
            </p>

            <div className="footer__newsletter">
              <h4 className="footer__newsletter-title">
                <i className="fa-regular fa-envelope"></i>
                Stay Updated
              </h4>
              <p className="footer__newsletter-text">
                Subscribe for exclusive offers and updates
              </p>

              <form onSubmit={handleSubmit} className="footer__form">
                <div className="footer__input-wrapper">
                  <input
                    type="email"
                    value={email}
                    onChange={e => {
                      setEmail(e.target.value);
                      setError('');
                      setSubscribed(false);
                    }}
                    placeholder="Enter your email"
                    className="footer__input"
                  />
                  <button type="submit" className="footer__submit">
                    <i className="fa-solid fa-paper-plane"></i>
                  </button>
                </div>
              </form>

              {error && (
                <div className="footer__message footer__message--error">
                  <i className="fa-solid fa-circle-exclamation"></i>
                  {error}
                </div>
              )}
              {subscribed && (
                <div className="footer__message footer__message--success">
                  <i className="fa-solid fa-circle-check"></i>
                  Successfully subscribed!
                </div>
              )}
            </div>

            <div className="footer__social">
              <p className="footer__social-title">Connect With Us</p>
              <div className="footer__social-links">
                <a
                  href="https://www.facebook.com/share/1DHrxCHdpt/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="Facebook"
                >
                  <div className="footer__social-icon">
                    <i className="fa-brands fa-facebook-f"></i>
                  </div>
                  <span className="footer__social-tooltip">Facebook</span>
                </a>

                <a
                  href="https://www.instagram.com/melmonsindia?igsh=MTljNzMxMHR3cXhkeQ%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="Instagram"
                >
                  <div className="footer__social-icon footer__social-icon--instagram">
                    <i className="fa-brands fa-instagram"></i>
                  </div>
                  <span className="footer__social-tooltip">Instagram</span>
                </a>

                <a
                  href="#"
                  className="footer__social-link"
                  aria-label="Pinterest"
                >
                  <div className="footer__social-icon footer__social-icon--pinterest">
                    <i className="fa-brands fa-pinterest-p"></i>
                  </div>
                  <span className="footer__social-tooltip">Pinterest</span>
                </a>

                <a
                  href="https://youtube.com/@melmonsindia?si=khz0gVJfapD0vFD4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label="YouTube"
                >
                  <div className="footer__social-icon footer__social-icon--youtube">
                    <i className="fa-brands fa-youtube"></i>
                  </div>
                  <span className="footer__social-tooltip">YouTube</span>
                </a>

                <a
                  href="#"
                  className="footer__social-link"
                  aria-label="LinkedIn"
                >
                  <div className="footer__social-icon footer__social-icon--linkedin">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </div>
                  <span className="footer__social-tooltip">LinkedIn</span>
                </a>

                <a
                  href="#"
                  className="footer__social-link"
                  aria-label="Telegram"
                >
                  <div className="footer__social-icon footer__social-icon--telegram">
                    <i className="fa-brands fa-telegram"></i>
                  </div>
                  <span className="footer__social-tooltip">Telegram</span>
                </a>
              </div>
            </div>
          </div>

          {/* Shop With Us */}
          <div className="footer__section footer__section--links">
            <h3 className="footer__heading">
              <i className="fa-solid fa-cart-shopping"></i>
              Shop With Us
            </h3>
            <ul className="footer__list">
              <li>
                <span className="footer__disabled-link">
                  <i className="fa-brands fa-amazon"></i>
                  Amazon <small className="coming-soon">(Coming soon)</small>
                </span>
              </li>
              <li>
                <span className="footer__disabled-link">
                  <i className="fa-solid fa-bag-shopping"></i>
                  Flipkart <small className="coming-soon">(Coming soon)</small>
                </span>
              </li>
              <li>
                <span className="footer__disabled-link">
                  <i className="fa-solid fa-store"></i>
                  Jiomart <small className="coming-soon">(Coming soon)</small>
                </span>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer__section footer__section--links">
            <h3 className="footer__heading">
              <i className="fa-solid fa-building"></i>
              Company
            </h3>
            <ul className="footer__list">
              <li>
                <a href="/about">
                  <i className="fa-solid fa-angle-right"></i>About Us
                </a>
              </li>
              <li>
                <a href="/privacy">
                  <i className="fa-solid fa-angle-right"></i>Privacy Policy
                </a>
              </li>
              <li>
                <a href="/privacy">
                  <i className="fa-solid fa-angle-right"></i>Return & Refund
                </a>
              </li>
              <li>
                <a href="/terms">
                  <i className="fa-solid fa-angle-right"></i>Terms of Service
                </a>
              </li>
              <li>
                <a href="/contact">
                  <i className="fa-solid fa-angle-right"></i>Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Get in Touch */}
          <div className="footer__section footer__section--contact">
            <h3 className="footer__heading">
              <i className="fa-solid fa-headset"></i>
              Get in Touch
            </h3>
            <ul className="footer__list footer__list--contact">
              <li className="footer__contact-item">
                <i className="fa-solid fa-envelope"></i>
                <a href="mailto:CARE@Example.IN">melmonsindia@gmail.com</a>
              </li>
              <li className="footer__contact-item">
                <i className="fa-solid fa-phone"></i>
                <a href="tel:+91">+91-9826009200</a>
              </li>
              <li className="footer__contact-item">
                <i className="fa-brands fa-whatsapp"></i>
                <a href="https://wa.me/91">+91-9826009200</a>
              </li>
              <li className="footer__time">
                <i className="fa-regular fa-clock"></i>
                Mon - Sat: 10:00 AM to 6:00 PM
              </li>
            </ul>

            <div className="footer__address">
              <h4 className="footer__address-heading">
                <i className="fa-solid fa-location-dot"></i>
                Corporate Office
              </h4>
              <p>Melmons India</p>
              <p>Khajrana, Indore</p>
              <p>Madhya Pradesh, 452016</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__divider"></div>
          <div className="footer__copyright">
            <p>
              <i className="fa-regular fa-copyright"></i>
              {new Date().getFullYear()} Melmons India. All rights reserved.
            </p>
            <div className="footer__payment">
              <span>We Accept:</span>
              <i className="fa-brands fa-cc-visa"></i>
              <i className="fa-brands fa-cc-mastercard"></i>
              <i className="fa-brands fa-cc-paypal"></i>
              <i className="fa-solid fa-credit-card"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
